const GRID_TO_API_SORT_FIELD: Record<string, string> = {
  customer: 'customerName',
  customerName: 'customerName',
  createdAt: 'createdAt',
  totalValue: 'total_value',
  nsOrderId: 'nsOrderId',
  store: 'store',
}

const API_TO_GRID_SORT_FIELD: Record<string, string> = {
  customerName: 'customer',
  'customer.name': 'customer',
  createdAt: 'createdAt',
  totalValue: 'totalValue',
  total_value: 'totalValue',
  total: 'totalValue',
  nsOrderId: 'nsOrderId',
  store: 'store',
}

export function mapGridOrderFieldToApi(field: string): string {
  return GRID_TO_API_SORT_FIELD[field] ?? field
}

export function mapApiOrderFieldToGrid(field: string): string {
  return API_TO_GRID_SORT_FIELD[field] ?? field
}
